import { render, staticRenderFns } from "./OrderProcessStepSwitch.vue?vue&type=template&id=5ffe0073&"
import script from "./OrderProcessStepSwitch.vue?vue&type=script&lang=js&"
export * from "./OrderProcessStepSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports